import { gql } from "@apollo/client";

const GET_INVOICE_ASSESSMENT_DETAILS = gql`
  query getInvoiceAssessmentDetails(
    $clientIdentifier: String!
    $invoiceId: String!
  ) {
    invoice(clientIdentifier: $clientIdentifier, invoiceId: $invoiceId) {
      id
      invoiceFileId
      invoiceNumber
      invoiceDate
      dueDate
      isCreditInvoice
      serviceType
      state {
        assessmentStatus
      }
      tags {
        invoiceTagId
        tag
      }
      template {
        id
        name
      }
      invoiceRecipient {
        client {
          id
          name
        }
        clientIdentifier
        distributionType
        ediAddress
        recipientEmail
        address1
        city
        zipCode
        countryCode
        name
      }
      latestAssessment {
        invoiceAssessmentId
        passed
        manualReviewRequired
        rules {
          invoiceAssessmentRuleId
          message
          passed
          ruleName
          ruleType
          score
          warning
          limitOption {
            limitType
          }
          exemptionOption {
            defaultEndDateDays
            relationType
            requiredValueType
            canCreateExemption
          }
        }
        ruleOverrides {
          createdAt
          invoiceAssessmentRuleId
          overriddenByUser {
            id
            firstName
            lastName
          }
          reason
        }
      }
      uploadDocument {
        id
        comments(skip: 0, take: 5) {
          totalCount
          items {
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
            id
          }
        }
        invoiceRecipientEmails
        invoiceRecipientGln
        userMessage
        serviceType
        invoiceUploadUnit {
          id
          emailDetails {
            isHtml
            messageId
            previewBody
            rawBody
            receivedDate
            recipients
            sentFromEmail
            subject
          }
          isBlacklisted
        }
      }
      hasDuplicateInvoices
    }
  }
`;

export default GET_INVOICE_ASSESSMENT_DETAILS;
